export const formatKeywordForUrl = (keyword: string): string => {
  const formattedKeyword = keyword
    .replace(/\/([^\s/]+)/g, '($1)') // /포 → (포), 한글 포함
    .replace(/[\s+]+/g, '-') // 공백, + → 하이픈
    .replace(/%/g, '퍼센트') // % → 퍼센트
    .replace(/[=&?#]/g, ''); // =, &, ?, # → 제거
  return formattedKeyword;
};

export const formatAuthorType = (authorType: string): string => {
  return authorType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
};
